import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-primary mb-4">404</h1>
          <h2 className="text-3xl font-semibold text-primary mb-4">Page Not Found</h2>
          <p className="text-lg text-secondary mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="space-y-4 mb-8">
          <Link
            to="/"
            className="block w-full bg-blue-600 text-white py-3 px-6 rounded-md font-medium hover:bg-blue-700 transition-colors"
          >
            Go to Homepage
          </Link>

          <Link
            to="/templates"
            className="block w-full border border-gray-300 text-secondary py-3 px-6 rounded-md font-medium hover:bg-gray-50 transition-colors"
          >
            Browse Templates
          </Link>
        </div>

        <div className="border-t border-gray-200 pt-8">
          <h3 className="font-semibold text-primary mb-3">Popular Pages</h3>
          <div className="grid grid-cols-2 gap-3 text-sm">
            <Link to="/templates" className="text-blue-600 hover:underline">
              Templates
            </Link>
            <Link to="/audit" className="text-blue-600 hover:underline">
              Audit Service
            </Link>
            <Link to="/account" className="text-blue-600 hover:underline">
              My Account
            </Link>
            <a href="mailto:support@dealvelocity.co.za" className="text-blue-600 hover:underline">
              Contact Support
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
